module.exports = __webpack_public_path__ + "img/empty_job_alert.d7cf4c27.svg";